import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'

/** Documents légaux (CGU, CGV) que l'utilisateur connecté doit accepter (#360). */
export const GQL_MY_LEGAL_ACCEPTANCE = typedGql('query')({
  myLegalAcceptance: {
    pending: { document: true, version: true },
  },
})

export const GQL_ACCEPT_LEGAL_DOCUMENTS = typedGql('mutation')({
  acceptLegalDocuments: [
    { documents: $('documents', '[LegalDocument!]!') },
    { pending: { document: true, version: true } },
  ],
})
